import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './GeneralContractorComponent.metadata.json5';
import styles from "../BuildersRisk.module.scss";
import PriorProjectComponent from '../SubComponents/PriorProject/PriorProjectComponent';

function GeneralContractorComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('GeneralContractorComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const getGenConName = useCallback(()=> {
        if(!modelVM.ifnoistheappactastconFie.value ) {
            return undefined
        }
        
        const getFirstName = _.get(submissionVM.value, 'lobData.accountHolder.firstName') || '';
                const getLastName = _.get(submissionVM.value, 'baseData.accountHolder.lastName') || '';
                const getDisplayName = _.get(submissionVM.value, 'baseData.accountHolder.displayName');
        const getAccountDisplayName = !getDisplayName
                    ? `${getFirstName} ${getLastName}`
                    : getDisplayName;
                    
        return _.trim(getAccountDisplayName)
                    || _.get(submissionVM.value, 'baseData.accountHolder.contactName')
                    || _.get(submissionVM.value, 'baseData.accountName');
    },[modelVM, submissionVM]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        priorProjectComponent:{
            data: modelVM.priorProjects,
            updateWizardData,
            submissionVM,
            PriorCurrentProjectsPath: `${pathUpdated}.priorProjects`
        },
        ifYESexpDatAmoDesFie: {
            visible: modelVM.havyouowngenconproyeaFie.value === true
        },
        ifnoistheappactastconFie: {
            visible: modelVM.ispromanbygenconFie.value === false
        },
        ifNOPleexpFie: {
            visible: !_.isUndefined(modelVM.doeGenConcarCGLFie.value) && !modelVM.doeGenConcarCGLFie.value
        },
        ispromanbygenconFie: {
            defaultValue: true
        },
        doeGenConcarCGLFie: {
            defaultValue: true
        },
        havyouowngenconproyeaFie: {
            defaultValue: false
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            priorProjectComponent: PriorProjectComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if(changedPath === 'yeainBusFie' && value > 99999999) {
                return 
            }

            if(changedPath === 'ifnoistheappactastconFie') {
                _.set(modelVM.value, 'genConNamFie', getGenConName())
            }

            if(changedPath === 'ispromanbygenconFie' && value === true) {
                _.set(modelVM.value, 'genConNamFie', undefined)
            }

            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [getGenConName, modelVM, pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

GeneralContractorComponent.propTypes = wizardProps;
export default withRouter(GeneralContractorComponent);
